import { render } from "./MailingBlockRaw.vue?vue&type=template&id=b2e1c446"
import script from "./MailingBlockRaw.vue?vue&type=script&lang=js"
export * from "./MailingBlockRaw.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__